import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import SpeciesSearchInput from './SpeciesSearchInput'
import {
  TaxonomicGroupFilter,
  CriteriaStatusFilter,
  UnderAssessmentFilter
} from './SpeciesTableFilters'
import {
  SpeciesTableToolbarWrapper,
  SpeciesToolbarGrid,
  SpeciesToolbarFilters,
  SpeciesSearchField,
  SpeciesFieldLabel,
  SpeciesToolbarMeta,
  SpeciesResultsSummary,
  SpeciesToolbarClearButton
} from './style'

const SpeciesTableToolbar = ({
  species,
  search,
  onSearchChange,
  taxonomicGroup,
  onTaxonomicGroupChange,
  criteriaStatus,
  onCriteriaStatusChange,
  underAssessment,
  onUnderAssessmentChange,
  filteredCount,
  totalCount,
  hasActiveFilters,
  onClearFilters,
  showUnderAssessmentFilter = false
}) => {
  const filterCount = showUnderAssessmentFilter ? 3 : 2

  return (
    <SpeciesTableToolbarWrapper data-test="species-criteria-met-toolbar">
      <SpeciesToolbarGrid $filterCount={filterCount}>
        <SpeciesSearchField>
          <SpeciesFieldLabel htmlFor="species-criteria-met-search">
            <FormattedMessage id="search" />
          </SpeciesFieldLabel>
          <SpeciesSearchInput value={search} onChange={onSearchChange} />
        </SpeciesSearchField>
        <SpeciesToolbarFilters>
          <TaxonomicGroupFilter
            species={species}
            value={taxonomicGroup}
            onChange={onTaxonomicGroupChange}
          />
          <CriteriaStatusFilter value={criteriaStatus} onChange={onCriteriaStatusChange} />
          {showUnderAssessmentFilter ? (
            <UnderAssessmentFilter value={underAssessment} onChange={onUnderAssessmentChange} />
          ) : null}
        </SpeciesToolbarFilters>
      </SpeciesToolbarGrid>

      <SpeciesToolbarMeta>
        <SpeciesResultsSummary data-test="species-criteria-met-results-summary">
          <FormattedMessage
            id="speciesCriteriaMetResultsSummary"
            values={{ filtered: filteredCount, total: totalCount }}
          />
        </SpeciesResultsSummary>
        {hasActiveFilters ? (
          <SpeciesToolbarClearButton type="button" onClick={onClearFilters}>
            <FormattedMessage id="clearFilters" />
          </SpeciesToolbarClearButton>
        ) : null}
      </SpeciesToolbarMeta>
    </SpeciesTableToolbarWrapper>
  )
}

SpeciesTableToolbar.propTypes = {
  species: PropTypes.arrayOf(PropTypes.object).isRequired,
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  taxonomicGroup: PropTypes.string.isRequired,
  onTaxonomicGroupChange: PropTypes.func.isRequired,
  criteriaStatus: PropTypes.string,
  onCriteriaStatusChange: PropTypes.func,
  underAssessment: PropTypes.string,
  onUnderAssessmentChange: PropTypes.func,
  filteredCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  showUnderAssessmentFilter: PropTypes.bool
}

export default SpeciesTableToolbar
